import React from "react";
import { AddAction } from "components/buttons";
import { Restricted, permissions } from "components/auth";

const ActionButtons = () => (
  <Restricted permissions={[permissions.source_manage]}>
    <AddAction url={"/source/new"} />
  </Restricted>
);

export default ActionButtons;
